export default __webpack_public_path__ + "static/homepage_testimonial_background_mobile-117b62a7a194e905598b620f2464e6e9.svg";